<div class="container" fxLayout="row">
    <optsol-ngx-forgot-password-form (formSubmit)="submit($event)" [disableSubmitButton]="false" fxFlex="40%">
        <img brandImage [src]="'assets/images/logo.png'" width="50%" />
        <span title class="mat-h2">Customer Portal</span>
        <img poweredByImage [src]="'assets/images/optsol.png'" />
        <ng-container links>
            <a [routerLink]="['/']">Sign In</a>
        </ng-container>
    </optsol-ngx-forgot-password-form>
  </div>